<script>
	import PageSection from "../../components/PageSection.svelte";
	import RadioGroup from "../../components/RadioGroup.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { acceptedFileUploadList, yesNoOptions, projectSettings } from "../../config";
	import { pageNumber, model } from "../../stores";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;
	export let disabled = null;
	export let title = null;

	if (!disabled) {
		pageNumber.update((p) => pageIndex);
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	let options = {
		url: "/api/file-upload?token=" + $model.RegistrationToken,
		acceptedFiles: acceptedFileUploadList
	};

	$model.documentList = $model.documentList || [];
</script>

<PageSection>
	<h2>Details</h2>

	<form novalidate autocomplete="off">
		{#if !disabled}
			<p>
				If you are unable to complete any part of this section of the form, we are here to assist you. Please
				contact us on <span style="white-space:nowrap">{projectSettings.phoneNumber}</span> or via email to
				<a href="mailto:{projectSettings.emailAddress}" target="_blank" rel="noreferrer noopener"
					>{projectSettings.emailAddress}</a
				>.
			</p>
		{/if}
		<div class="form-row">
			<div class="form-group col-md-12">
				<label class:isrequired={!disabled}
					>Were you a passenger on the Ruby Princess Cruise that departed Circular Quay on 8th March 2020?</label
				>
				<RadioGroup
					{disabled}
					name="RubyPrincessPassenger"
					bind:value={$model.RubyPrincessPassenger}
					optionList={yesNoOptions}
					required
				></RadioGroup>
				<div class="radio-error"></div>
			</div>
		</div>

		<div class="form-row">
			<div class="form-group col-md-12">
				<label class:isrequired={!disabled}
					>Are you an executor, administrator or personal representative of the estate of a passenger who
					contracted coronavirus on the cruise and subsequently passed away?</label
				>
				<RadioGroup
					{disabled}
					name="EstateContact"
					bind:value={$model.EstateContact}
					optionList={yesNoOptions}
					required
				></RadioGroup>
				<div class="radio-error"></div>
			</div>
		</div>

		<div class="form-row">
			<div class="form-group col-md-12">
				<label class:isrequired={!disabled}
					>Are you a family member or loved one of an ill or deceased passenger who has suffered a psychiatric
					injury as a result of their loved one’s contracting the virus on the cruise?</label
				>
				<RadioGroup
					{disabled}
					name="FamilyMember"
					bind:value={$model.FamilyMember}
					optionList={yesNoOptions}
					required
				></RadioGroup>
				<div class="radio-error"></div>
			</div>
		</div>

		<div class="form-row">
			<div class="form-group col-md-12">
				<label class:isrequired={!disabled}>Do you have any supporting documentation?</label>
				<RadioGroup
					{disabled}
					name="SupportingDocuments"
					bind:value={$model.SupportingDocuments}
					optionList={yesNoOptions}
					required
				></RadioGroup>
				<div class="radio-error"></div>
			</div>
		</div>

		{#if $model.SupportingDocuments == "Yes"}
			<div class="form-row">
				<!-- <div class="form-row" transition:slide> -->
				<div class="form-group col-md-12">
					<label for="openingBalance">Please upload a copy of your supporting documents</label>
					<DropZone
						{disabled}
						{options}
						id="dz"
						message="Drop files here or click to upload."
						bind:documentList={$model.documentList}
					></DropZone>
				</div>
			</div>
		{/if}

		<div class="form-row">
			<div class="form-group col-md-12">
				<label for="addinfo">Is there anything you want to tell us?</label>
				<textarea
					id="addinfo"
					bind:value={$model.AdditionalInformation}
					rows="4"
					class="form-control"
					{disabled}
				></textarea>
			</div>
		</div>

		{#if !disabled}
			<div class="form-row">
				<div class="col-md-12 last">
					<NavigationButtons {persistUrl} {previousPage} {nextPage} tealiumTag={true} pageName={title}
					></NavigationButtons>
				</div>
			</div>
		{/if}
	</form>
</PageSection>
